import { AppActions, AppTypes } from './appTypes';

const appReducer = (state: AppTypes, action: AppActions) => {
    switch (action.type) {
        case 'SET_LOADING':
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [action.payload.loadingKey]: action.payload.loadingState,
                },
            };
        case 'SET_SELECTED_SPOOL':
            return {
                ...state,
                selectedSpool: action.payload,
            };
        case 'SET_SELECTED_EMISSION_SPOOL':
            return {
                ...state,
                selectedEmissionSpool: action.payload,
            };
        case 'SET_CURRENT_VIEWING_MODEL':
            return {
                ...state,
                currentViewingRiskModel: action.payload,
            };

        case 'SET_RISK_MODELS':
            return {
                ...state,
                riskModels: action.payload,
            };
        case 'SET_STRATEGIES':
            return {
                ...state,
                strategies: action.payload,
            };

        case 'SET_ESTIMATED_ALLOCATIONS':
            return {
                ...state,
                estimatedAllocations: action.payload,
            };

        default:
            return {
                ...state,
            };
    }
};

export default appReducer;
